module.exports = __webpack_public_path__ + "static/media/animated-circle-checkbox-icon.3d6fb7ab.svg";